window.anvil.block('carousel-2', (el, data) => {
    const sliderElement = el.querySelector('.slider-carousel');

    if (sliderElement) {
        new Swiper(sliderElement, {
            autoHeight: true,
            autoplay: data.autoplay ? {
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
                reverseDirection: true
            } : false,
            slidesPerView: 1,
            lazy: true,
            speed: 500,
            initialSlide: data.effect != 'slide' ? 0 : (data.slides.length - 1),
            observer: true,
            observeParents: true,
            effect: data.effect ? data.effect : 'fade',
            loop: data.effect != 'slide' ? false : true,
            fadeEffect: data.effect != 'slide' ? { crossFade: true } : false,
            pagination: {
                el: el.querySelector('.js-indicator'),
                type: 'fraction',
                formatFractionCurrent: function (number) {
                    return ('0' + number).slice(-2);
                },
                formatFractionTotal: function (number) {
                    return ('0' + number).slice(-2);
                },
                renderFraction: function (currentClass, totalClass) {
                    return '<strong class="' + currentClass + '"></strong>' +
                        '/' +
                        '<strong class="' + totalClass + '"></strong>';
                }
            },
            navigation: {
                prevEl: el.querySelector('.js-prev'),
                nextEl: el.querySelector('.js-next')
            },
            breakpoints: {
                1025: {
                    autoHeight: false
                }
            }
        });
    }
});
